var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEasy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6e7d94;}.b{clip-path:url(#a);}.c{fill:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 84,
    height: 84,
    transform: "translate(1244 4875)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-1244 -4875)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1244 4875)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 84,
    height: 84
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M77,18.13,37.065,58.1,22.225,43.26l4.935-4.935,9.905,9.9,35-35ZM69.265,35.77A27.982,27.982,0,1,1,42,14a27.723,27.723,0,0,1,14.98,4.375l5.04-5.04A34.65,34.65,0,0,0,42,7,35.093,35.093,0,1,0,74.9,30.135Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasy);
export default __webpack_public_path__ + "static/media/easy.838a6f0790c60df464f0714a601f69fc.svg";
export { ForwardRef as ReactComponent };